import React, {useEffect, useState} from 'react';
import {Box, Card, CardBody, CardHeader, Text} from '@chakra-ui/react';
import axios from 'axios';
import _ from 'lodash';
import {CloseIcon} from '@chakra-ui/icons';
import ButtonMinor from '../../../../components/ButtonMinor';
import ButtonCircleIcon from '../../../../components/ButtonCircleIcon';
import {sendExploreWiki} from '../../../../vuplex';
import {MdMyLocation} from 'react-icons/md';
import {FaWikipediaW} from 'react-icons/fa';

const WikiActionPanelContent = ({onClose, wikipedia}) => {
  const [wikiData, setWikiData] = useState(null);

  useEffect(() => {
    if (!wikipedia) {
      setWikiData(null);
      return;
    }

    const {
      photoUrl,
      title,
      wikiPageId,
    } = wikipedia;

    const fetchWiki = async () => {
      const res = await axios.get(`https://en.wikipedia.org/api/rest_v1/page/summary/${title}`, {
        headers: {
          'Api-User-Agent': `Wooorld/v2.0(info@wooorld.io)`,
        },
      })
        .catch(err => {

        });

      setWikiData({
        ...res.data,
        photoUrl: _.get(res, 'data.thumbnail.source', photoUrl),
        wikiPageId,
      });
    };

    fetchWiki();
  }, [wikipedia]);


  return wikiData && (
    <Card borderRadius="2xl">
      <CardHeader
        backgroundImage={wikiData.photoUrl}
        backgroundPosition="center"
        backgroundSize="cover"
        h={wikiData.photoUrl ? '10em' : '2em'}
        justifyContent="space-between"
        display="flex"
      >
        {wikiData.wikiPageId ? (
          <ButtonCircleIcon
            icon={<FaWikipediaW size="1.5em"/>}
            tooltip={`Open full article`}
            onClick={() => {
              sendExploreWiki({
                wikiPageId: wikiData.wikiPageId,
              });
              onClose();
            }}/>
        ) : <Box>/*to keep X button on right*/</Box>}

        <ButtonMinor boxShadow={`0px 0px 10px 0px #000`} p={0} onClick={onClose}>
          <CloseIcon color="black24"/>
        </ButtonMinor>
      </CardHeader>

      <CardBody>
        <Text noOfLines={5}>
          {wikiData.extract}
        </Text>
      </CardBody>

    </Card>);
};

export default WikiActionPanelContent;